"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withReduxForm = _interopRequireDefault(require("../../libs/hocs/withReduxForm"));

var _utils = require("../../libs/utils");

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _options = _interopRequireDefault(require("./options"));

var _container = _interopRequireDefault(require("./styled/container"));

var _label = _interopRequireDefault(require("../Input/label"));

var _innerContainer = _interopRequireDefault(require("./styled/innerContainer"));

var _select = _interopRequireDefault(require("./styled/select"));

var _errorText = _interopRequireDefault(require("../Input/styled/errorText"));

var _helpText = _interopRequireDefault(require("../Input/styled/helpText"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Select element presents a menu of options.
 * @category Form
 */


var Select = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Select, _Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Select);
    _this = _super.call(this, props);
    _this.selectId = (0, _utils.uniqueId)('select');
    _this.selectRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  /**
   * Sets focus on the element.
   * @public
   */


  (0, _createClass2["default"])(Select, [{
    key: "focus",
    value: function focus() {
      this.selectRef.current.focus();
    }
    /**
     * Sets click on the element.
     * @public
     */

  }, {
    key: "click",
    value: function click() {
      this.selectRef.current.click();
    }
    /**
     * Sets blur on the element.
     * @public
     */

  }, {
    key: "blur",
    value: function blur() {
      this.selectRef.current.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          value = _this$props.value,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onClick = _this$props.onClick,
          bottomHelpText = _this$props.bottomHelpText,
          error = _this$props.error,
          required = _this$props.required,
          disabled = _this$props.disabled,
          options = _this$props.options,
          style = _this$props.style,
          className = _this$props.className,
          id = _this$props.id,
          name = _this$props.name,
          labelAlignment = _this$props.labelAlignment,
          hideLabel = _this$props.hideLabel,
          tabIndex = _this$props.tabIndex,
          variant = _this$props.variant;
      return /*#__PURE__*/_react["default"].createElement(_container["default"], {
        className: className,
        style: style,
        id: id
      }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
        label: label,
        labelAlignment: labelAlignment,
        hideLabel: hideLabel,
        required: required,
        inputId: this.selectId
      }), /*#__PURE__*/_react["default"].createElement(_innerContainer["default"], {
        error: error,
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement(_select["default"], {
        error: error,
        id: this.selectId,
        name: name,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        value: value,
        tabIndex: tabIndex,
        required: required,
        disabled: disabled,
        variant: variant,
        ref: this.selectRef
      }, /*#__PURE__*/_react["default"].createElement(_options["default"], {
        options: options
      }))), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: bottomHelpText
      }, /*#__PURE__*/_react["default"].createElement(_helpText["default"], null, bottomHelpText)), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: error
      }, /*#__PURE__*/_react["default"].createElement(_errorText["default"], null, error)));
    }
  }]);
  return Select;
}(_react.Component);

Select.propTypes = {
  /** Text label for the Select. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The name of the Select. */
  name: _propTypes["default"].string,

  /** Specifies the selected value. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** The action triggered when a option item is selected. */
  onChange: _propTypes["default"].func,

  /** The action triggered when the element is clicked. */
  onClick: _propTypes["default"].func,

  /** The action triggered when the element receives focus. */
  onFocus: _propTypes["default"].func,

  /** The action triggered when the element releases focus. */
  onBlur: _propTypes["default"].func,

  /** Shows the help message below the Select. */
  bottomHelpText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Specifies that an input field must be filled out before submitting the form.
   * This value defaults to false. */
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Specifies that an input field must be filled out before submitting the form.
   * This value defaults to false. */
  required: _propTypes["default"].bool,

  /** Specifies that an input element should be disabled. This value defaults to false. */
  disabled: _propTypes["default"].bool,

  /** The option items to be displayed. */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    disabled: _propTypes["default"].bool
  })),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /** The id of the outer element. */
  id: _propTypes["default"].string,

  /** Describes the position of the Select label. Options include left, center and right.
   * This value defaults to center. */
  labelAlignment: _propTypes["default"].oneOf(['left', 'center', 'right']),

  /** A boolean to hide the Select label. */
  hideLabel: _propTypes["default"].bool,

  /** Specifies the tab order of an element (when the tab button is used for navigating). */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** The variant changes the appearance of the Select. Accepted variants include default
   * and shaded. This value defaults to default. */
  variant: _propTypes["default"].oneOf(['default', 'shaded'])
};
Select.defaultProps = {
  label: undefined,
  value: undefined,
  name: undefined,
  onChange: function onChange() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  bottomHelpText: null,
  error: null,
  required: false,
  disabled: false,
  options: [],
  className: undefined,
  style: undefined,
  id: undefined,
  labelAlignment: 'center',
  hideLabel: false,
  tabIndex: undefined,
  variant: 'default'
};

var _default = (0, _withReduxForm["default"])(Select);

exports["default"] = _default;